import './style/base-style.css'
import userCircleIcon from './images/images-rentApp/User_Circle.svg'
import heartIcon from './images/images-rentApp/heart-icon.svg'
import bookIcon from './images/images-rentApp/bookmark-icon.svg'
import messageIcon from './images/images-rentApp/message-icon.svg'
import searchIcon from './images/images-rentApp/search-icon.svg'
import locationIcon from './images/images-rentApp/location.svg'


import {useState, useRef} from 'react'

import Table from './Table'
import FavedPopup from './FavedPopup'
import SavedSrchPopup from './SavedSrchPopup'


export default function Latest(){



    function Header (){

        return(
            
            <div className='header'>
    
                <div className='siteLogo'> RentIn<span>DE</span></div> 
                <div style={{width: '45%'}}></div>
                <div className='userMenu'>
                    <div className='menuIconsGroup'>
                        <div className='menuIcons' ><img src={messageIcon}/></div>
                        <div className='menuIcons' onClick={(()=> {setSavedSPopup(!SavedSPopup) ; if (FavedPop) {setFavedPop(!FavedPop)}})}><img src={bookIcon}/></div>
                         <div className='menuIcons' onClick={(()=> {setFavedPop(!FavedPop); if (SavedSPopup) {setSavedSPopup(!SavedSPopup)}} )}><img src={heartIcon}/></div>                    </div>
                    <div><img src={userCircleIcon}/></div>
                    <div>
                        <div className='font21'>Adam</div>
                        <div style={{'font-size': '15px'}}>adamzucker@gmail.com</div>
                    </div>
                </div>
        </div>
    
    )
    
    }

    function SearchBar(){

        const [BookClicked, setBookClicked] = useState('')
        const [BookBorder, setBookBorder] = useState('')

        const handleBookClick = () => {
            BookClicked === '' ? setBookClicked('invert(67%) sepia(33%) hue-rotate(90deg) saturate(50%)'): setBookClicked('')
            }  

        return(

            <div className='searchBar'>
                
                
                <div style={{display: 'flex', gap: '11px'}}>
                   <img src={locationIcon} style={{transform: 'scale(1)'}}/>

                <input placeholder=' Darmsdat'/>
                </div>

                <input placeholder=' WG, 1-Zimmer Wohnung, Wohnung'/>
                <div> Offers</div>

                <div style={{display: 'flex', gap: '11px'}}>

                    <div className='circleButton'  onClick={()=>{handleBookClick()}}> <img src={bookIcon} style={{transform: 'scale(.9)', filter: BookClicked}}/></div>
                    <div className='myButton'>Search<img src={searchIcon}/></div>

                </div>

                
            </div>
        )

    }
    
    const apparts = {
        list:[
                {
                date: '10.08.2214',
                title: 'Sunny Flat near City Center',
                location: 'Köln',
                type: 'Wohnug',
                amenities: ['kitchen','parking'],
                duration: 'Long Term',
                inclus: 'Yes',
                available: '01.09.2024',
                price: ['kalt',290],
                },
            
                {
                    date: '14.08.2024',
                    title: 'Sunny Flat near Stadt Mall',
                    location: 'Hamburg',
                    type: '1-Zimmer-Wohnug',
                    amenities: ['furnished','kitchen','parking'],
                    duration: 'Long Term',
                    inclus: 'Yes',
                    available: '01.09.2024',
                    price: ['warm',410],
                },
                {
                    date: '19.08.2024',
                    title: 'Shared Appartment in Munchen Park',
                    location: 'Frankfurt',
                    type: 'WG',
                    amenities: ['furnished'],
                    duration: 'Long Term',
                    inclus: 'Yes',
                    available: '01.09.2024',
                    price: ['warm',410],
                },
                {
                    date: '20.08.2024',
                    title: 'Sunny Flat near City Center',
                    location: 'Langen',
                    type: 'Wohnug',
                    amenities: ['kitchen','parking'],
                    duration: 'Long Term',
                    inclus: 'Yes',
                    available: '01.09.2024',
                    price: ['kalt',290],
                    },
                {
                date: '21.08.2014',
                title: 'Beautiful Appartment near Bonn Park ',
                location: 'Munchen',
                type: '1-Zimmer-Wohnug',
                amenities: ['furnished','kitchen'],
                duration: 'Long Term',
                inclus: 'Yes',
                available: '01.09.2024',
                price: ['kalt',320],
                }
            ]
    }

    const FavedPopRef = useRef(null)
    const SavedSrchPopupRef = useRef(null)
    const [FavedPop, setFavedPop] = useState(false)
    const [SavedSPopup, setSavedSPopup] = useState(false)

    return (
        <div className='layout'>
            <Header/>
            <SearchBar/>
            <div style={{position: 'inherit', top: '-153px', right: '-43px'}}>{FavedPop && <FavedPopup FavOffers={apparts} setFavedPop = {setFavedPop} ref ={FavedPopRef} />}</div>
            <div style={{position: 'inherit', top: '-183px', right: '-43px'}}>{SavedSPopup && <SavedSrchPopup SavedSearches = {apparts} setSavedSPopup = {setSavedSPopup} ref ={SavedSrchPopupRef} />}</div>
            <Table apparts={apparts}/>
        </div>
    )

}